if (!customElements.get('calmi-bogo-variant-combo')) {
  customElements.define(
    'calmi-bogo-variant-combo',
    class CalmiBogoVariantCombo extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select.calmi-bogo-combo__native');
        this.trigger = this.querySelector('[data-combo-trigger]');
        this.panel = this.querySelector('[data-combo-panel]');
        this.list = this.querySelector('[data-combo-list]');
        this.mode = this.dataset.mode || 'bundle';
        this.optionSublabel = this.dataset.optionSublabel || 'color';

        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);

        this.trigger?.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const willOpen = Boolean(this.panel?.hidden);
          if (willOpen) this.selectOwningBogoCard();
          this.toggle();
        });

        this.list?.addEventListener('click', (e) => {
          const opt = e.target.closest('.calmi-bogo-combo__option-item');
          if (!opt || opt.disabled) return;
          e.preventDefault();
          e.stopPropagation();
          this.chooseOption(opt);
        });
      }

      disconnectedCallback() {
        this.close();
      }

      selectOwningBogoCard() {
        const wrap = this.closest('.calmi-bogo-bundle__card-wrap');
        const picker = this.closest('product-bogo-picker');
        const offer = this.mode === 'single' ? 'single' : 'bundle';
        const radio =
          wrap?.querySelector('.product-bogo-offer__radio') ||
          picker?.querySelector(`.product-bogo-offer__radio[value="${offer}"]`);
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      toggle() {
        if (this.panel?.hidden) this.open();
        else this.close();
      }

      open() {
        if (!this.panel || !this.trigger) return;
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
      }

      close() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        if (this.panel) this.panel.hidden = true;
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      }

      onDocClick(e) {
        if (!this.contains(e.target)) this.close();
      }

      onKey(e) {
        if (e.code === 'Escape') this.close();
      }

      chooseOption(optionEl) {
        if (!this.select) return;

        if (this.mode === 'bundle') {
          const vid = optionEl.dataset.variantId;
          if (!vid) return;
          this.select.value = vid;
        } else {
          const val = optionEl.dataset.optionValue;
          if (val == null) return;
          this.select.value = val;
          this.syncVariantSelects(val);
        }

        this.select.dispatchEvent(new Event('change', { bubbles: true }));

        this.list.querySelectorAll('.calmi-bogo-combo__option-item').forEach((btn) => {
          const sel = btn === optionEl;
          btn.classList.toggle('is-selected', sel);
          btn.setAttribute('aria-selected', sel ? 'true' : 'false');
        });

        this.updateTriggerFromOption(optionEl);
        this.close();
      }

      syncVariantSelects(optionValue) {
        const productInfo = this.closest('product-info');
        const vs = productInfo?.querySelector('variant-selects');
        const nativeSelect = vs?.querySelector('select[name^="options"]');
        if (!nativeSelect) return;
        const match = Array.from(nativeSelect.options).find((o) => o.value === optionValue);
        if (!match) return;
        nativeSelect.value = optionValue;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateTriggerFromOption(optionEl) {
        if (!this.trigger) return;
        const swatch = optionEl.querySelector('.calmi-bogo-combo__swatch-img');
        const nameEl = optionEl.querySelector('.calmi-bogo-combo__target-name b');
        const name = nameEl?.textContent?.trim() || '';
        const wrap = this.trigger.querySelector('.calmi-bogo-combo__trigger-inner');
        if (!wrap) return;

        const swatchHost = wrap.querySelector('.calmi-bogo-combo__swatch');
        const textHost = wrap.querySelector('.calmi-bogo-combo__trigger-text');
        if (swatchHost) {
          swatchHost.innerHTML = '';
          if (swatch) {
            const clone = swatch.cloneNode(true);
            swatchHost.appendChild(clone);
          }
        }
        if (textHost) {
          textHost.innerHTML = `<b class="calmi-bogo-combo__trigger-name">${this.escapeHtml(name)}</b><span class="calmi-bogo-combo__trigger-sublabel">${this.escapeHtml(this.optionSublabel)}</span>`;
        }
      }

      escapeHtml(text) {
        const d = document.createElement('div');
        d.textContent = text;
        return d.innerHTML;
      }
    }
  );
}
